import http from '../../services/httpService';
import apiEndpoint from '../../constants/config.json'

//create method create_new_check_out_order

export function fetchAllMemories(){
    const fullApiEndpoint = apiEndpoint.apiEndpoint + "/memoriesManagement/api/fetch_all_memories/";
    return http.get(fullApiEndpoint);
}